import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { routing } from '../../../app.routing';
import { ButtonGroupDirective } from './button-group.directive';
import { ButtonsTranslations } from './buttons-translations.service';
import { PageSpinnerComponent } from './page-spinner/page-spinner.component';
import { SpinnerComponent } from './spinner/spinner.component';
import { SpinnerService } from './spinner/spinner.service';
import { SubmitRowButtonsComponent } from './submit-row-buttons/submit-row-buttons.component';

/**
 * Module for the Manage section
 */
@NgModule({
  declarations: [
    SubmitRowButtonsComponent,
    SpinnerComponent,
    PageSpinnerComponent,
    ButtonGroupDirective
  ],
  exports: [
    SubmitRowButtonsComponent,
    SpinnerComponent,
    PageSpinnerComponent,
    ButtonGroupDirective
  ],
  providers: [
    ButtonsTranslations,
    SpinnerService,
  ],
  imports: [
    routing,
    CommonModule,
  ]
})
export class ButtonsModule { }
